import { observer } from 'mobx-react-lite'
import { TextField, makeTextFieldAutoFocus, makeTextFieldIcon } from 'shared/ui/TextField'
import { Button } from 'shared/ui'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'

import styles from './styles.module.scss'

export const SavedRepliesSearch = observer(() => {
  const { search, setSearch, prevItem, nextItem, clearSearch } = useSavedRepliesContext()

  const handleHotKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
    switch (e.code) {
      case 'ArrowUp':
        return prevItem()
      case 'ArrowDown':
        return nextItem()
      default:
        return
    }
  }

  return (
    <div className={styles.searchWrapper}>
      <div className={styles.searchInputWrap}>
        <TextField
          className={styles.textField}
          variant='integrated'
          InputProps={{ placeholder: 'Search', onKeyDown: handleHotKeys }}
          value={search}
          leftActions={[
            makeTextFieldIcon({
              icon: 'search',
              color: 'var(--content-primary-tertiary)',
              fontSize: 20,
              margin: '0 6px 0 0',
            }),
          ]}
          size='medium'
          onChange={setSearch}
          mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
        />
      </div>
      {search && (
        <Button
          text={'Clear'}
          contained={'secondary'}
          typeBtn={'text'}
          onClick={clearSearch}
          size={'medium'}
        />
      )}
    </div>
  )
})
